import React from 'react';
import styled from '@benzinga/themetron';
import { BzImage, buildCloudflareImageUrl } from '@benzinga/image';
import { GallerySlideProps } from '.';

export const GalleryCarouselItem: React.FC<GallerySlideProps> = ({ image }) => {
  if (!image) return null;
  const blurredImage = buildCloudflareImageUrl(image, 'width=30,dpr=1,format=auto,quality=85');
  return (
    <GalleryCarouselItemContainer className="gallery-carousel-item">
      <div className="thumbnail">
        <BzImage
          alt=""
          //blurDataURL={blurredImage}
          height="100%"
          layout="fill"
          objectFit="cover"
          //placeholder="blur"
          src={image}
          width="100%"
        />
      </div>
      <BlurPlaceholder $url={blurredImage} className="blur-placeholder" />
    </GalleryCarouselItemContainer>
  );
};

const GalleryCarouselItemContainer = styled.div`
  &.gallery-carousel-item {
    width: 100%;
    padding: 0 60px;
    background-color: #cecece;
  }

  .thumbnail {
    position: relative;
    overflow: hidden;
    background-color: transparent;
    padding-bottom: 67.7135%;
    cursor: pointer;
    z-index: 2;
  }
`;

const BlurPlaceholder = styled.div<{ $url: string; $opacity?: number }>`
  background: url(${({ $url }) => $url});
  position: absolute;
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-size: cover;
  filter: blur(${({ $opacity }) => `${$opacity || 20}px`});
  top: 0;
  left: 0;
`;
